import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Switch from "react-switch";

// css
import styles from "./AssignChecklist.module.scss";
import { Formik, Field } from "formik";
import assignChecklistSchema from "./assignChecklist.schema";
import { CommonSelect, RequiredFieldAstrick } from "components/Common/Common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import { successMessageToast, userFullName } from "helpers/common";
import { useGetMdtTherapistStatusListQuery } from "store/services/utility";
import { useAssignCheckListMutation } from "store/services/MDT/assessment";
import LoadingIndicator from "components/shared/LoadingIndicator";
import moment from "moment";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";

const AssignChecklistPop = ({ assignChecklist, setAssignChecklist, therapistOptions }) => {

  const [checked, setChecked] = useState(false);
  
  const initialValues = { caseload_therapist_id: "", action: "", status: "", deadline: "", send_notification: "no" };
  const therapistOptionsList = therapistOptions?.map(item => ({ value: item?.id, label: userFullName(item?.clientCaseloadMapping?.[0]?.caseTherapist) }));

  // Status list
  const { data: statusList, isLoading: statusListLoading } = useGetMdtTherapistStatusListQuery();
  const [assignCheckList, { isLoading: assignCheckListLoading }] = useAssignCheckListMutation();

  const handleChecklistPop = () => setAssignChecklist(!assignChecklist);

  const handleSubmit = async (values) => {
    try {
      let payload = {
        ...values,
        caseload_therapist_id: values?.caseload_therapist_id?.value,
        status: values?.status?.value,
      }
      let { data, error } = await assignCheckList(payload);
      if (error) return;

      successMessageToast(data?.message);
      setAssignChecklist(false);
    } catch (err) {
      console.error("Error assigning checklist", err);
    }
  };

  return (
    <>
      <Modal
        show={assignChecklist}
        className={`${styles.AssignChecklist}  AssignChecklist`}
        onHide={handleChecklistPop}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
      >
        <Formik
          initialValues={initialValues}
          validationSchema={assignChecklistSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            handleSubmit,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <div className="d-flex align-items-center justify-content-between gap-10 w-100">
                  <h6 className="m-0 fw-bold themeBlue">Add Checklist</h6>
                  <div className="right d-flex align-items-center gap-10">
                    <h6 className="m-0 fw-bold" style={{ fontSize: 12 }}>
                      Send notification
                    </h6>
                    <div className=" d-flex align-items-center">
                      <p className="m-0 text-muted mx-1">Off</p>
                      <Switch
                        uncheckedIcon={""}
                        checkedIcon={""}
                        onHandleColor={"#A3DF00"}
                        offHandleColor={"#A3DF00"}
                        onColor={"#E6E6E6"}
                        offColor={"#E6E6E6"}
                        height={18}
                        width={40}
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                      />
                      <p className="m-0 text-muted mx-1">On</p>
                    </div>
                  </div>
                </div>
              </Modal.Header>
              <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                <Button
                  onClick={handleChecklistPop}
                  className="border-0 p-0 position-absolute"
                  variant="transparent"
                  style={{ right: 10, top: 0 }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 16 15"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_0_6282)">
                      <path
                        d="M1.98638 14.906C1.61862 14.9274 1.25695 14.8052 0.97762 14.565C0.426731 14.0109 0.426731 13.1159 0.97762 12.5617L13.0403 0.498994C13.6133 -0.0371562 14.5123 -0.00735193 15.0485 0.565621C15.5333 1.08376 15.5616 1.88015 15.1147 2.43132L2.98092 14.565C2.70519 14.8017 2.34932 14.9237 1.98638 14.906Z"
                        fill="white"
                      />
                      <path
                        d="M14.0347 14.9061C13.662 14.9045 13.3047 14.7565 13.0401 14.4941L0.977383 2.4313C0.467013 1.83531 0.536401 0.938371 1.13239 0.427954C1.66433 -0.0275797 2.44884 -0.0275797 2.98073 0.427954L15.1145 12.4907C15.6873 13.027 15.7169 13.9261 15.1806 14.4989C15.1593 14.5217 15.1372 14.5437 15.1145 14.5651C14.8174 14.8234 14.4263 14.9469 14.0347 14.9061Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_0_6282">
                        <rect
                          width="15"
                          height="15"
                          fill="white"
                          transform="translate(0.564453)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </Button>
                <Form>
                  <Row className="">
                    <Col md="6" className="my-2 my-lg-3">
                      <div className="d-flex align-items-center justify-content-between pb-2">
                        <h6
                          className="m-0 fw-sbold themeBlue d-flex"
                          style={{ fontSize: 14 }}
                        >
                          Select Therapist
                          <RequiredFieldAstrick />
                        </h6>
                      </div>
                      <CommonSelect
                        name="caseload_therapist_id"
                        placeholder="Select Therapist"
                        className={`${styles.formControl}`}
                        option={therapistOptionsList}
                      />
                    </Col>
                    <Col md="6" className="my-2 my-lg-3">
                      <div className="d-flex align-items-center justify-content-between pb-2">
                        <h6
                          className="m-0 fw-sbold themeBlue d-flex"
                          style={{ fontSize: 14 }}
                        >
                          Action Item
                          <RequiredFieldAstrick />
                        </h6>
                        <i
                          className="text-muted m-0"
                          style={{ fontSize: 10, lineHeight: "14px" }}
                        >
                          (text box from administration)
                        </i>
                      </div>
                      <AppInputField
                        name="action"
                        type="text"
                        placeholder="Enter Request"
                        className={`${styles.formControl} form-control`}
                        maxLength={100}
                      />
                    </Col>
                    <Col md="6" className="my-2 my-lg-3">
                      <div className="d-flex align-items-center justify-content-between pb-2">
                        <h6
                          className="m-0 fw-sbold themeBlue d-flex"
                          style={{ fontSize: 14 }}
                        >
                          Status
                          <RequiredFieldAstrick />
                        </h6>
                        <i
                          className="text-muted m-0"
                          style={{ fontSize: 10, lineHeight: "14px" }}
                        >
                          (text box for therapist)
                        </i>
                      </div>
                      <CommonSelect
                        name="status"
                        placeholder="Select Status"
                        className={`${styles.formControl}`}
                        option={statusList?.map(item => ({ value: item?.id, label: item?.title }))}
                        isLoading={statusListLoading}
                      />
                    </Col>
                    <Col md="6" className="my-2 my-lg-3">
                      <div className="d-flex align-items-center justify-content-between pb-2">
                        <h6
                          className="m-0 fw-sbold themeBlue d-flex"
                          style={{ fontSize: 14 }}
                        >
                          Deadline Date
                          <RequiredFieldAstrick />
                        </h6>
                      </div>
                      <AppDatePicker
                        name="deadline"
                        className={`${styles.formControl} form-control`}
                        minDate={moment().add(1, "day").format("YYYY-MM-DD")}
                      />
                    </Col>
                  </Row>
                </Form>
              </Modal.Body>
              <Modal.Footer className="justify-content-start">
                <Button
                  type="submit"
                  disabled={assignCheckListLoading}
                  className="d-flex align-items-center justify-content-center commonBtn"
                >
                  {assignCheckListLoading ? <LoadingIndicator inline /> : "Save & Send Notification"}

                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default AssignChecklistPop;
